export default __webpack_public_path__ + "static/media/logos-flag.e19579a7.png";